import { useEffect } from 'react'
import CountUp from 'react-countup';
import { useNavigate, useParams } from "react-router-dom";
import '../../assets/css/referral.scss';
import { WaitingLoader } from '../../hooks/buttonLoad';
import { useGetReferLevels } from './UserDetailapi';
import { NoDataFound } from '../../lib/loader';


const ReferralManagement = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { data: getWidget, isLoading } = useGetReferLevels({
        userId: id
    })

    useEffect(() => {
        const interval = setInterval(() => {
            const cards = document.querySelectorAll('.custm-dashboard_rd');
            cards.forEach(card => {
                card.classList.add('animate');
                setTimeout(() => {
                    card.classList.remove('animate');
                }, 1000);
            });
        }, 5000);

        return () => clearInterval(interval);
    }, []);


    const getDecimalPlaces = (value, defaultDecimals = 5) => {
        if (typeof value !== 'number') return 0;
        return value % 1 !== 0 ? defaultDecimals : 0;
    };



    return (
        <>
            {isLoading && <WaitingLoader />}
            <div>
                <h3>Referral Management</h3>
            </div>

            {getWidget?.data?.data?.length > 0 ? (
                <div className="row gy-4 mt-4">
                    {getWidget?.data?.data?.length > 0 &&
                        getWidget.data.data.map((item) => {
                            const {
                                level,
                                members,
                                recvReward,
                                missedReward,
                                currencyImage
                            } = item;

                            const adjustedLevel = level + 1
                            const displayUserLevel = adjustedLevel === 1 ? 'Direct' : `Level ${adjustedLevel}`;

                            return (
                                <div key={level} className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                                    <div className="ad_pg_cd_cnt">
                                        <h4>{displayUserLevel}</h4>
                                        <div className="custm-dashboard_rd">
                                            {/* Top Section */}
                                            <div className="custm-dashboard_rcnt tp">
                                                <button className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                                        <button
                                                            className="col-auto ad_pg_cd_c"
                                                            onClick={() =>
                                                                navigate(`/singleuser-referral-history/${id}/${level}`)}
                                                                style={{ cursor: 'pointer' , background : 'unset' , border : 'unset'}}
                                                        >
                                                            <div className="custm-dashboard_lb">User Level</div>
                                                            <div className="custm-dashboard_vl">{adjustedLevel}</div>
                                                        </button>
                                                        <button
                                                            className="col-auto ad_pg_cd_c"
                                                            onClick={() => navigate(`/singleuser-referral-history/${id}/${level}`)}
                                                            style={{ cursor: 'pointer' , background : 'unset' , border : 'unset'}}
                                                        >
                                                            <div className="custm-dashboard_lb">Members</div>
                                                            <div className="custm-dashboard_vl">
                                                                <CountUp end={members} />
                                                            </div>
                                                        </button>
                                                    </div>
                                                </button>
                                            </div>

                                            {/* Bottom Section */}
                                            <div className="custm-dashboard_rcnt bm">
                                                <button className="custm-dashboard_cnt w-100 bg-transparent border-0 p-0 text-white">
                                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                                        <button
                                                            className="col-auto ad_pg_cd_c"
                                                            onClick={() => navigate(`/user-cashback/${id}/${level}/cashback`)}
                                                            style={{ cursor: 'pointer' , background : 'unset' , border : 'unset'}}
                                                        >
                                                            <div className="custm-dashboard_lb">Received</div>
                                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                                <CountUp end={recvReward} decimals={getDecimalPlaces(recvReward)} />
                                                                {currencyImage && (
                                                                    <img
                                                                        src={currencyImage}
                                                                        alt="Currency Icon"
                                                                        style={{
                                                                            height: '20px',
                                                                            width: '20px',
                                                                            borderRadius: '50%',
                                                                            verticalAlign: 'middle',
                                                                            objectFit: 'cover',
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </button>
                                                        <button
                                                            className="col-auto ad_pg_cd_c"
                                                            onClick={() => navigate(`/user-cashback-missed/${id}/${level}/missed`)}
                                                            style={{ cursor: 'pointer' , background : 'unset' , border : 'unset'}}
                                                        >
                                                            <div className="custm-dashboard_lb">Missed</div>
                                                            <div className="custm-dashboard_vl d-flex gap-1 align-items-center">
                                                                <CountUp end={missedReward} decimals={getDecimalPlaces(missedReward)} />
                                                                {currencyImage && (
                                                                    <img
                                                                        src={currencyImage}
                                                                        alt="Currency Icon"
                                                                        style={{
                                                                            height: '20px',
                                                                            width: '20px',
                                                                            borderRadius: '50%',
                                                                            verticalAlign: 'middle',
                                                                            objectFit: 'cover',
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </button>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            ) : (
                <NoDataFound/>
            )}


        </>

    )
}

export default ReferralManagement;
